import { useId } from "react";

import { cn } from "@/lib/utils";

export function AwardsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-6.5 w-5", className)}
      fill="none"
      viewBox="0 0 20 26"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${id})`}>
        <path
          d="M15.502 4.614a.257.257 0 00-.214-.114h-3.864c-.1 0-.191.058-.232.148L9.767 7.753a.246.246 0 000 .206l1.261 2.749c.041.09.132.147.233.147h1.34c.1 0 .191-.058.233-.147l2.687-5.855a.246.246 0 00-.019-.239z"
          fill="#D62D2D"
        />
        <path
          d="M10.319 6.55l-.552 1.203a.246.246 0 000 .205l1.261 2.75c.041.09.132.147.233.147h1.033L10.32 6.55z"
          fill="#9E1219"
        />
        <path
          clipRule="evenodd"
          d="M9.033 11.303a.96.96 0 00.968.95.96.96 0 00.968-.95.96.96 0 00-.968-.948.96.96 0 00-.968.948zm.512 0c0-.247.205-.448.457-.448s.458.201.458.448a.453.453 0 01-.458.449.453.453 0 01-.457-.449z"
          fill="#FFA035"
          fillRule="evenodd"
        />
        <path
          d="M11.495 10.502L8.808 4.648a.256.256 0 00-.233-.148H4.712a.257.257 0 00-.214.114.246.246 0 00-.019.239l2.687 5.855c.041.09.133.147.233.147h3.863a.257.257 0 00.214-.114.246.246 0 00.019-.239z"
          fill="#FF3D43"
        />
        <path
          d="M10.457 10.855h.804a.257.257 0 00.215-.114.246.246 0 00.018-.239L8.807 4.648a.256.256 0 00-.232-.148H7.54l2.916 6.355z"
          fill="#D72E2E"
        />
        <path
          d="M10.007 11.752c-2.741 0-4.972 2.186-4.972 4.874 0 2.687 2.23 4.874 4.972 4.874 2.742 0 4.972-2.187 4.972-4.874 0-2.688-2.23-4.874-4.972-4.874z"
          fill="#FFC850"
        />
        <path
          d="M10.008 11.752c-.2 0-.4.012-.594.035 2.462.289 4.378 2.348 4.378 4.839 0 2.49-1.916 4.55-4.378 4.84.195.022.393.034.594.034 2.742 0 4.972-2.186 4.972-4.874 0-2.688-2.23-4.874-4.972-4.874z"
          fill="#F4B70C"
        />
        <path
          d="M10.008 13.092c-1.988 0-3.606 1.585-3.606 3.534 0 1.949 1.618 3.534 3.606 3.534 1.988 0 3.605-1.585 3.605-3.534 0-1.949-1.617-3.534-3.605-3.534z"
          fill="#FFF5CF"
        />
        <path
          d="M10.008 13.092c-.19 0-.377.014-.559.042 1.724.264 3.047 1.73 3.047 3.492s-1.323 3.228-3.047 3.492c.182.027.369.042.559.042 1.988 0 3.605-1.585 3.605-3.534 0-1.949-1.617-3.534-3.605-3.534z"
          fill="#FFECA1"
        />
        <path
          d="M12.052 16.503a.553.553 0 00.146-.579.569.569 0 00-.465-.384l-.801-.114a.065.065 0 01-.05-.035l-.358-.712a.573.573 0 00-.516-.315c-.22 0-.419.12-.516.315l-.359.712a.065.065 0 01-.049.035l-.802.114a.57.57 0 00-.464.384.553.553 0 00.145.579l.58.554a.063.063 0 01.02.056l-.138.783a.556.556 0 00.23.552.581.581 0 00.606.043l.716-.37a.066.066 0 01.061 0l.717.37c.195.1.428.084.606-.043a.556.556 0 00.23-.552l-.137-.783a.063.063 0 01.018-.056l.58-.554z"
          fill="#FFA035"
        />
        <path
          d="M12.052 16.502a.553.553 0 00.146-.578.57.57 0 00-.465-.384l-.039-.006-1.17 1.103a.31.31 0 00-.092.278l.27 1.548.053.028c.195.1.428.084.606-.043a.556.556 0 00.23-.552l-.138-.783a.063.063 0 01.019-.056l.58-.555z"
          fill="#F78819"
        />
        <path
          d="M13.352 10.855h-6.7a.253.253 0 01-.256-.25c0-.138.115-.25.256-.25h6.7c.14 0 .255.112.255.25s-.114.25-.255.25z"
          fill="#FFC850"
        />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="25"
          id={id}
          width="19.086"
          x="0.457"
          y="0.5"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_17358_6488"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_17358_6488"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function CouponsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-3 w-4.5", className)}
      fill="none"
      viewBox="0 0 18 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M1.322 11.246H5.25V.864H1.322c-.35 0-.687.134-.935.371A1.24 1.24 0 000 2.131v1.44c0 .194.14.361.338.402a2.25 2.25 0 011.257.747c.318.378.492.85.494 1.335a2.083 2.083 0 01-.493 1.336 2.246 2.246 0 01-1.258.746A.416.416 0 000 8.54v1.44c0 .336.14.658.387.895.248.238.584.37.935.37zm4.785 0H16.68c.35 0 .686-.134.934-.372.247-.237.387-.559.387-.895V2.131c0-.336-.14-.658-.387-.895a1.352 1.352 0 00-.934-.372H6.107v10.382z"
        fill={`url(#${id})`}
        fillRule="evenodd"
      />
      <path
        d="M12.416 7.41a1.31 1.31 0 01.432-.985c.14-.13.297-.231.473-.302a1.51 1.51 0 01.584-.113c.209 0 .4.038.577.113.181.07.339.171.472.302.139.125.246.273.32.444.08.165.12.346.12.542 0 .196-.04.379-.12.55a1.393 1.393 0 01-.32.444c-.133.125-.29.226-.472.3a1.527 1.527 0 01-.577.106c-.208 0-.403-.035-.584-.105a1.689 1.689 0 01-.473-.301 1.579 1.579 0 01-.32-.444 1.355 1.355 0 01-.112-.55zm2.21 0c0-.19-.07-.35-.208-.481a.72.72 0 00-.513-.196.72.72 0 00-.512.196.635.635 0 00-.208.482c0 .19.07.351.208.482a.72.72 0 00.512.196.72.72 0 00.513-.196.635.635 0 00.208-.482zM8.613 4.7c0-.195.038-.376.112-.542a1.466 1.466 0 01.793-.745 1.51 1.51 0 01.584-.113c.209 0 .4.038.577.113.181.07.339.17.472.301.139.126.246.274.32.444.08.166.12.347.12.542 0 .196-.04.38-.12.55a1.391 1.391 0 01-.32.444c-.133.126-.29.226-.472.301-.176.07-.368.106-.577.106-.208 0-.403-.035-.584-.106a1.688 1.688 0 01-.472-.3 1.578 1.578 0 01-.32-.445 1.355 1.355 0 01-.113-.55zm2.21 0c0-.19-.07-.351-.208-.481a.72.72 0 00-.513-.196.72.72 0 00-.512.196.635.635 0 00-.208.481c0 .191.07.352.208.482a.72.72 0 00.512.196.72.72 0 00.513-.196.635.635 0 00.208-.482zm2.522-1.55l.664.286-3.33 5.526-.665-.286 3.33-5.527z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="1.601"
          x2="14.616"
          y1="10.648"
          y2="2.891"
        >
          <stop stopColor="#6315ea" />
          <stop offset="1" stopColor="#ef67b0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function FlashIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-5 w-4", className)}
      fill="none"
      viewBox="0 0 16 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${id}a)`}>
        <path
          clipRule="evenodd"
          d="M7.869 3.044l-.167.308a10615.463 10615.463 0 01-2.574 4.755 1440.348 1440.348 0 01-1.196 2.209c-.087.16.034.353.223.353l.974.002a62.79 62.79 0 011.389.01 445.73 445.73 0 00-.26.486l-.224.414a2168.863 2168.863 0 01-1.404 2.592l-.286.53a3211.762 3211.762 0 01-1.242 2.29c-.014.024.03-.01.173-.13a396.449 396.449 0 011.182-.989 2333.308 2333.308 0 013.18-2.66 697.984 697.984 0 011.644-1.375 412.404 412.404 0 01.98-.819l.638-.533c.312-.26.536-.448 1.14-.955.076-.062.03-.181-.07-.181l-1.1-.002a68.652 68.652 0 01-1.387-.01c0-.004.076-.147.169-.319a683.35 683.35 0 00.82-1.514 3586.066 3586.066 0 001.845-3.407l.36-.665c.123-.227.224-.417.224-.423 0-.008-.735-.011-2.504-.011H7.944a.084.084 0 00-.075.044z"
          fill={`url(#${id}b)`}
          fillRule="evenodd"
        />
      </g>
      <g filter={`url(#${id}c)`}>
        <path
          clipRule="evenodd"
          d="M11.467 3L7.65 10h2.8L3.1 17l.03-.018c.028-.02.075-.059.145-.118l.588-.492.595-.498L5.98 14.6l.255-.214.806-.674.595-.498.535-.448a762.781 762.781 0 001.526-1.275l.562-.47a742.219 742.219 0 001.78-1.488c.075-.063.028-.182-.071-.182l-1.1-.002a68.56 68.56 0 01-1.388-.01c0-.004.076-.147.17-.319l.317-.586.503-.928.51-.944a706.978 706.978 0 011.037-1.913l.297-.55.361-.666c.123-.226.223-.416.223-.422 0-.006-.432-.01-1.432-.01z"
          fill={`url(#${id}d)`}
          fillRule="evenodd"
        />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}b`}
          x1="3.358"
          x2="16.549"
          y1="16.067"
          y2="6.634"
        >
          <stop stopColor="#ffcf55" />
          <stop offset="1" stopColor="#bd2885" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}d`}
          x1="2.308"
          x2="15.498"
          y1="16.767"
          y2="7.335"
        >
          <stop stopColor="#c79b29" />
          <stop offset="1" stopColor="#bd2885" />
        </linearGradient>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="19.6"
          id={`${id}a`}
          width="15.4"
          x="0.3"
          y="0.2"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.929348 0 0 0 0 0.44144 0 0 0 0 0.524009 0 0 0 0.1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18271_77694"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_18271_77694"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="19.599"
          id={`${id}c`}
          width="15.4"
          x="0.3"
          y="0.2"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.929348 0 0 0 0 0.44144 0 0 0 0 0.524009 0 0 0 0.2 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18271_77694"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_18271_77694"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function SavedIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-4.5 w-3.5 text-berry", className)}
      viewBox="0 0 16 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 3a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.6L1 19V3z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SponsoredIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-5.5 w-19.5 text-transparent", className)}
      fill="none"
      viewBox="0 0 78 22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        fill="currentColor"
        height="21.5"
        rx="2.75"
        width="77.5"
        x="0.25"
        y="0.25"
      />
      <rect
        height="21.5"
        rx="2.75"
        stroke={`url(#${id})`}
        strokeWidth="0.5"
        width="77.5"
        x="0.25"
        y="0.25"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="38.886"
          x2="38.886"
          y1="0"
          y2="22"
        >
          <stop stopColor="#eb297b" />
          <stop offset="1" stopColor="#9b3699" />
        </linearGradient>
      </defs>
    </svg>
  );
}
